import type { ReactNode } from 'react';

import Typo from '@/components/Typography/Typo';
import { Tooltip } from '@/shared/ui/tooltip';
import { FeedbackSentiment, sentimentMap } from '@/types/feedbackConst';

type FeedbackGalleryCardBlockListProps = {
  blocks: FeedbackBlockT[];
  getTooltipContent: (label: string, value: string) => ReactNode;
};

const FeedbackGalleryCardBlockList = ({
  blocks,
  getTooltipContent,
}: FeedbackGalleryCardBlockListProps) => {
  if (blocks.length === 0) return null;

  return (
    <div className="space-y-1.5 px-4 py-2">
      {blocks.map((block) => {
        const blockSentiment =
          sentimentMap[
            (block.sentiment || FeedbackSentiment.NEUTRAL)
          ] || sentimentMap[FeedbackSentiment.NEUTRAL];

        return (
          <div
            key={block.alias}
            className="flex items-center justify-between gap-2 py-0.5"
          >
            <Tooltip
              disableHoverableContent
              content={getTooltipContent('Block', block.snippet)}
            >
              <Typo type="body2" className="min-w-0 flex-1 truncate text-gray-900">
                {block.snippet}
              </Typo>
            </Tooltip>
            <div className="flex shrink-0 items-center gap-2">
              <Tooltip
                disableHoverableContent
                content={getTooltipContent('Sentiment', blockSentiment.value)}
              >
                <div className="flex items-center">{blockSentiment.icon}</div>
              </Tooltip>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FeedbackGalleryCardBlockList;

